import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import styled from '@emotion/styled';
import { Link } from '@mui/material';

export default function MobileMenu(props) {
  const [state, setState] = React.useState({top: false});

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const MenuWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
  `
  const SiteLogo = styled.img`
    max-width: 180px;
    height: auto;
  `
  const MenuIcon = styled.span`
    color: #ffffff;
    font-size: 50px;
  `

  const MenuLink = styled(Link)`
    color: #ffffff;
    text-decoration: none;
    cursor: pointer;
    font-family: "poppins"; 
    font-weight: 300;
    font-size: 15px;
    text-transform: uppercase;
    transition-duration: 0.5s;

    &:hover, &:active, &:focus{
        color: #00D3FD;
        transition-duration: 0.5s;
    }

    &:last-child{
        background: linear-gradient(225deg, #00D3FD, #7904FE, #F8063A);
        border-radius: 4px;
        border: unset;
        font-weight: 600;
        text-transform: unset;

        &:hover, &:active, &:focus{
            color: #ffffff;
            background: linear-gradient(225deg, #00D3FD 5%, #7904FE 50%, #F8063A 95%);
            box-shadow: 0 0 15px #00D3FD30, 0 0 25px #00D3FD30, 0 0 35px #00D3FD30;
        }
    }
`
  return (
    <MenuWrapper>
        <React.Fragment>
            <Link to="/">
                <SiteLogo src={props.siteLogo} />
            </Link>
            <Button onClick={toggleDrawer('left', true)}>
                { state['left'] ? 
                    <span class="material-symbols-outlined" style={{color: '#ffffff',fontSize: 30}}>menu_open</span>
                :
                    <span class="material-symbols-outlined" style={{color: '#ffffff',fontSize: 30}}>menu</span>
                }
            </Button>
            <Drawer
                anchor="left"
                open={state['left']}
                onClose={toggleDrawer('left', false)}
            >
                
                <Box
                    sx={{ width: 250,background: '#000029', minHeight: '100vh' }}
                    role="presentation"
                    onClick={toggleDrawer('left', false)}
                    onKeyDown={toggleDrawer('left', false)}
                    >
                        <Link to="/" className='d-inline-block pt-4 pl-4'>
                            <SiteLogo src={props.siteLogo} />
                        </Link>                        
                    <Divider />
                    <List>
                        {(props.menuList).map((text, index) => (
                            <MenuLink 
                                href={text[1]} 
                                className={text[3] + " d-block"}
                            >
                                {text[0]}
                            </MenuLink>
                        ))}
                    </List>
                    </Box>
            </Drawer>
        </React.Fragment>
    </MenuWrapper>
  );
}
